module.exports = "/shifts/components/coverShiftOptions-79d716.html";